import { memo } from 'react';
import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { QuestionIcon } from 'foundations-assets/icons/components/QuestionIcon';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { SmartPropertyRunStatusTooltip } from 'smart-property-lib';
import { useAIProcessingStatusWithMetadata } from '../ai/useAIProcessingStatusWithMetadata';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { fullWidthCellClassName } from '../utils/fullWidthCellClassName';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { useObjectId } from '../v2/hooks/useObjectId';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import { useProperty } from '../v2/hooks/useProperty';
import { SmartPropertyRunStatus } from '../ai/SmartPropertyRunStatus';

// We narrow the props down here so we can use this in the formatter as well
// without specifying all the props possible on the input. Props should never be
// added here that are not provided in PropertyInputV2
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputAIStatus = props => {
  useComponentMountMetric('PropertyInputAIStatus');
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const objectId = useObjectId();
  const {
    metadata,
    smartPropertyResultId,
    status
  } = useAIProcessingStatusWithMetadata(objectTypeId, property.name, objectId, {
    pollForStatus: false
  });
  if (smartPropertyResultId && (status === 'completedNoResult' || status === 'failed')) {
    return /*#__PURE__*/_jsx(SmartPropertyRunStatus, {
      error: metadata.error,
      smartPropertyResultId: smartPropertyResultId,
      status: status
    });
  }
  if (status === 'completedNoResult') {
    return /*#__PURE__*/_jsx(SmartPropertyRunStatusTooltip, {
      status: "COMPLETE_NO_RESULT",
      metadata: metadata,
      children: /*#__PURE__*/_jsx(IconCircle, {
        icon: QuestionIcon,
        size: "200",
        color: "fill-surface-default",
        marginInlineEnd: "50",
        backgroundColor: "fill-accent-red-default"
      })
    });
  }
  if (status === 'failed') {
    return /*#__PURE__*/_jsx(SmartPropertyRunStatusTooltip, {
      status: "FAILURE",
      metadata: metadata,
      children: (metadata === null || metadata === void 0 ? void 0 : metadata.error) === 'INVALID_AGENT_RESULT_PII_DETECTED' ? /*#__PURE__*/_jsx(IconCircle, {
        icon: QuestionIcon,
        size: "200",
        color: "fill-surface-default",
        marginInlineEnd: "50",
        backgroundColor: "fill-accent-red-default"
      }) : /*#__PURE__*/_jsx(IconHolder, {
        icon: WarningIcon,
        padding: "0",
        size: "400",
        color: "fill-accent-red-default"
      })
    });
  }
  return /*#__PURE__*/_jsx(AISkeleton, Object.assign({}, getTransferrableProps(props), {
    "data-classname": fullWidthCellClassName,
    height: "0.8em"
  }));
};
export default /*#__PURE__*/memo(PropertyInputAIStatus);